import { AppTheme } from "state/baseapplication/Reducer";

const Palette = (theme: AppTheme): any => ({
  primary: {
    contrastText: theme.primaryContrast,
    main: theme.primary,
  },
  secondary: {
    contrastText: theme.secondaryContrast,
    main: theme.secondary,
  },
});

export default Palette;
